import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { GenerateDocumentResponse } from '../../../../../conversations/src/api/createDocumentForConversation';

export interface GenerateQueryObject {
  conversation_included?: boolean;
  conversation_only?: boolean;
}

export const generateDocumentForReport = async (
  reportId: string,
  documentType: 'pdf' | 'docx',
  lang = 'en',
  queryObject: GenerateQueryObject = {},
): Promise<GenerateDocumentResponse> => {
  const path = `v1/api/advisory-reports/${reportId}/${documentType}`;
  const { data, isError } = await wgApi.post<GenerateDocumentResponse>(
    path,
    undefined,
    { query: { lang, ...queryObject } },
  );
  if (isError) throw new Error();
  return data;
};
